import type {ReactElement} from 'react';
import type {FooterLeftActionProps} from '@Components/ai-prompt-box/components/ai-prompt-box-footer-left-actions/ai-prompt-box-footer-left-actions.types';

export interface AiPromptBoxContextualMenuProps extends FooterLeftActionProps {
  onOpen?: VoidFunction;
  onOpenStateChange?: (isOpen: boolean) => void;
  modalShowBackButton?: boolean;
  maxContextualMenuWidth?: number;
  renderTooltip?: boolean;
  borderedSelector?: boolean;
  selector?: ReactElement;
  popupContentClassName?: string;
  modalContentClassName?: string;
  alignPopupWithFooter?: boolean;
}

export enum ContextualMenuGroupType {
  PILLS = 'pills',
  CARDS = 'cards',
  CHECKBOXES = 'checkboxes',
}

export enum ContextualMenuItemGraphicType {
  NONE = 'none',
  ICON = 'icon',
  IMAGE = 'image',
  EMOJI = 'emoji',
}

export interface ContextualMenuItem {
  label: string;
  value: string;
  active: boolean;
  description?: string;
  topRightIcon?: string;
  credits?: number;
  disabled?: boolean;
  tooltip?: string;
}

export interface ContextualMenuItemWithEmoji extends ContextualMenuItem {
  graphicType: ContextualMenuItemGraphicType.EMOJI;
  emoji: string;
}

export interface ContextualMenuItemWithIcon extends ContextualMenuItem {
  graphicType: ContextualMenuItemGraphicType.ICON;
  icon?: string;
  imageUrl?: string;
}

export interface ContextualMenuItemWithImage extends ContextualMenuItem {
  graphicType: ContextualMenuItemGraphicType.IMAGE;
  imageUrl: string;
}

export interface ContextualMenuItemWithoutGraphic extends ContextualMenuItem {
  graphicType: ContextualMenuItemGraphicType.NONE;
}

export interface ContextualMenuGroup {
  label: string;
  key: string;
  type: ContextualMenuGroupType;
  items: ContextualMenuItem[];
}

export type AiPromptBoxContextualMenu = ContextualMenuGroup[];
